import Organizations_AccessTokens_MyAccessTokensPage from "@Organizations/AccessTokens/Pages/MyAccessTokensPage.vue";
import Organizations_AccessTokens_ManageUserAccessTokensPage from "@Organizations/AccessTokens/Pages/ManageUserAccessTokensPage.vue";

export const routes = [
    // pages
    {
        path: "/organizations/accesstokens/my",
        component: Organizations_AccessTokens_MyAccessTokensPage
    },
    {
        path: "/organizations/accesstokens/manage/:id",
        component: Organizations_AccessTokens_ManageUserAccessTokensPage
    },
]
